export default "__VITE_ASSET__B3I_Qdop__"